<template>
  <div class="content__detail">
    <div v-if="data.is_new" class="content__detail__new font_hel bold">New</div>
    <a class="content__detail__title bold sample" :href="'/job/detail/' + data.id ">{{ data.name }}</a>
    <div class="content__detail__dark">
      <p><span>単価</span><span class="bold">{{formatPrice(data.price_from)}}〜{{formatPrice(data.price_to)}}</span><span>円／月</span></p>
      <p><span>勤務地</span><span class="bold">{{data.place}}</span></p>
      <p><span>期間</span><span class="bold">{{data.join}}</span></p>
      <p v-if="data.tags && data.tags.length"><span>スキル</span></p>
      <p><span v-for="(tag, index) in data.tags" v-bind:key="index">{{ tag.name }}</span></p>
    </div>
  </div>
</template>

<script>
import Form from "@/utils/Form";
import { formatPrice, formatDate } from '@/utils/Helper'

export default {
  props: {
    data: {
      type: Array | Object | null,
      default: null,
      required: false,
    }
  },
  components: {
  },
  data() {
    return {
      form: new Form({
      }),
    }
  },
  methods: {
    formatPrice(price) {
      return formatPrice(price / 10000) + '万'
    },

    formatDate(date) {
      return formatDate(date, 'YYYY.MM.DD')
    },

    formartNo(str) {
      return str.padStart(7, '0');
    },
  },
  mounted() {
  },
  computed: {

  }
}
</script>
